export default __webpack_public_path__ + "img/8ef29073ca6ae22e43cf3d4db62d8d19.svg";